// import BaseXMLGenerator from './xlsx-tableexport-generator.js';
// import { dateFormat, amountFormat } from '@/data/filters/formatter.js';

// var XMLGenerator = new BaseXMLGenerator();
// XMLGenerator.baseGenerate = XMLGenerator.generate
// XMLGenerator.generate = function (vm, datas) {
//     var rows = []
//     for (var data of datas) {
//         var row = []

//         row.push(dateFormat(data['date']))
//         row.push(data['user-name'])
//         row.push(data['content'])
//         row.push(data['isMoneyVisible'] ? amountFormat(data['bonus']) : '-')
//         row.push(data['hours'])
//         row.push(data['status'])
//         row.push(data['bonus-issuer-name'])
//         row.push(dateFormat(data['issued-at']))
    
//         rows.push(row)
//     }
//     let headerList = ['工作日期', '人員', '工作項目', '分配獎金', '實際時數', '狀態', '簽核', '簽核日期']
//     return this.baseGenerate(rows, headerList)
// }

// export default XMLGenerator;

// 從 table 產生
import TableExport from 'tableexport'

var XMLGenerator = {
  generate: function(theadID, fileName) {
    let thead = document.getElementById(theadID)
    let table = thead.parentElement
    let tableID = `table-of-${theadID}`
    table.id = tableID
    var exportedTable = TableExport(table, {
      formats: ['xlsx'],
      filename: fileName
    })
    
    return {
      xlsxData: exportedTable.getExportData()[tableID].xlsx,
      exportedTable: exportedTable
    }
  }
}
export default XMLGenerator;